import AnalyticsApi from '../api/AnalyticsApi';
import AnalyticsConstants from '../constants/AnalyticsConstants';

function fetchDataLayer() {
  return {
    types: [
      AnalyticsConstants.FETCH_DATALAYER_REQUEST,
      AnalyticsConstants.FETCH_DATALAYER_SUCCESS,
      AnalyticsConstants.FETCH_DATALAYER_FAILURE
    ],
    apiRequest: (state, client) => AnalyticsApi.fetchDataLayer(client)
  };
}

function setContext(contextName, context) {
  return {
    type: AnalyticsConstants.SET_CONTEXT,
    contextName,
    context
  };
}

export default {
  fetchDataLayer,
  setContext
};
